import React from "react";
import Button from "@material-ui/core/Button";
import HelpIcon from "@material-ui/icons/Help";
import { languages } from "../../constants/languages";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import IconButton from "@material-ui/core/IconButton";

const styles = theme => ({
  button: {
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  iconButton: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block"
    }
  }
});

class HelpMenuButton extends React.Component {
  render() {
    const props = this.props;

    return (
      <div>
        <Button
          className={props.classes.button}
          aria-owns={props.open ? "menu-appbar" : null}
          aria-haspopup="true"
          onClick={props.handleOpen}
          color="inherit"
          style={{ color: "white" }}
        >
          <HelpIcon style={{ height: 25, marginRight: 5 }} />
          <span className={props.classes.buttonText}>
            {languages.header.support}
          </span>
        </Button>
        <IconButton
          className={props.classes.iconButton}
          aria-owns={props.open ? "menu-appbar" : null}
          aria-haspopup="true"
          onClick={props.handleOpen}
          color="inherit"
          style={{ color: "white" }}
        >
          <HelpIcon style={{ height: 25, marginRight: 5 }} />
        </IconButton>
      </div>
    );
  }
}

HelpMenuButton.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(HelpMenuButton);
